import React, { FC, CSSProperties } from 'react';
import classnames from 'classnames';
import { createPortal } from 'react-dom';
import { ITooltipProps } from './type';

/** Tooltip rendered via portal to ensure correct positioning and visibility above all UI elements and fixing some z-index issues caused by the other one. */
export const PortalBaseTooltip: FC<ITooltipProps> = ({
  position,
  children,
  width = 'auto',
  wrapperClassName,
  tooltipRef,
  style,
}) => {
  const styles: CSSProperties = { width, ...style };
  if (position) {
    styles.top = `${position.y}px`;
    styles.left = `${position.x}px`;
  }

  const classes = classnames('fixed', wrapperClassName);

  const tooltipNode = (
    <div style={styles} className={classes} ref={tooltipRef}>
      {children}
    </div>
  );

  return typeof window !== 'undefined' ? createPortal(tooltipNode, document.body) : null;

};
